import { Component, Vue,  Prop  } from "vue-property-decorator";
@Component({
})
export default class TimeAnalysisBarChart extends Vue {
  @Prop({ default: () => ([]) }) readonly columns: Array<any>;
  @Prop({ default: () => ([]) }) readonly dataValue: any;
  @Prop({ default: null }) index: number

  mounted() {
    this.init()
  }

  seriesDataItem(key){
    const data = []
    this.dataValue.forEach(item => {
      data.push(item.wcsData[key.wcsName] || '0')
    });
    return data
  }

  init() {
    const seriesData = []
    const legendData = []
    this.dataValue.forEach(res =>{
      legendData.push(res.workStationName)
    })
    const color = {}
    this.columns.map(column =>{
      color[column.wcsName] = column.color
    })
    this.columns.forEach(res =>{
      const seriesValue = {
        name: res.wcsName,
        type: 'bar',
        data: this.seriesDataItem(res),
        label: {
          show: true,
          position: 'top'
        },
        itemStyle: {
          normal: {
            color: param => {
              return color[param.seriesName]
            }
          }
        }
      }
      seriesData.push(seriesValue)
    })
    // 基于准备好的dom，初始化echarts实例
    var myChart = (this as any).$echarts.init(
      this.$refs.myChart as any
    );
    // 指定图表的配置项和数据
    var option = {
      title:{
        show:false
      },
      tooltip: {
        trigger: 'axis',
        formatter: (val,ticket) =>{
          const html = []
          val.forEach(res => {
            const data = res.marker + res.seriesName + ': ' + res.data + 'h'
            html.push(data)
          });
          return html.join("<br />")
        },
        axisPointer: {
          type: 'shadow',          
          shadowStyle: {
            color: 'rgba(155,155,155,.03)',
            shadowColor: 'rgba(255,255,255,.2)'
          }
        },
      },
      legend: {
        show: false
      },
      grid: {
        left: '40',
        right: '40',
        bottom: '4%',
        top: '20',
        containLabel: true
      },
      color: color,
      xAxis: {
        type: 'category',
        axisLabel: {
          show: true,
          interval: 0
        },
        axisLine: {onZero: true},
        data: legendData
      },
      yAxis: [
        {
          type: 'value',
          boundaryGap: true,
          axisLine: {
              show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLabel:{
            formatter: value =>{
              return value + 'h'
            }
          },
        }
      ],
      series: seriesData
    };
    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option);
  }

  getheight(){
    const div = document.getElementById('black-main')
    return div.clientHeight - 110 + 'px'
  }
  
  render() {
    return (
      <div ref="myChart" style={{width: (65 * this.columns.length * this.dataValue.length) + 'px', height: this.getheight()}}></div>
    )
  }
}
